<template>
  <div class="nav-common fleft">
    <div class="nav-bar2">
      <div class="nav-top2">
        <el-menu :default-active="$route.path" router class="el-menu-demo" mode="horizontal">
          <el-menu-item index="0" @click="toLink">首页</el-menu-item>
          <el-submenu index="1">
            <template slot="title" class="title">我们</template>
            <el-menu-item index="/Culture">企业文化</el-menu-item>
            <el-menu-item index="/Introduction">简介</el-menu-item>
          </el-submenu>
          <el-submenu index="2">
            <template slot="title" class="title">服务</template>
            <el-menu-item index="/Mypromote">系统定制</el-menu-item>
            <el-menu-item index="/Resources">入口资源</el-menu-item>
            <el-menu-item index="/Fristagency">一级代理</el-menu-item>
            <el-menu-item index="/Personal">个人</el-menu-item>
          </el-submenu>
          <!-- <el-menu-item index="/Join">加入我们</el-menu-item> -->
        </el-menu>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Navcom2",
  data() {
    return {
      
    }
  },
  created() {},
  methods: {
    toLink(){
      window.open('http://www.92qb.cn')
    }
  },
  components: {

  }
};
</script>

<style lang="stylus" scoped>
  .nav-bar2
    margin 0 0 0 100px
  
  .el-menu--horizontal
    border-bottom 0

  .el-menu
    li
      height 97px
      line-height 97px
      font-size 20px
      color #000000
    
  .el-menu--horizontal>.el-menu-item.is-active
    border-bottom 0
    border-top 3px solid #123e96
    color #123e96  
        
</style>

<style type="text/css">
  
  .nav-top2 .el-menu--horizontal>.el-submenu.is-active .el-submenu__title{
    border-bottom:0;
    color:#123e96;
    border-top: 3px solid #123e96;
  }
  .nav-top2 .el-menu--horizontal>.el-submenu .el-submenu__title{
    height: 97px;
    line-height: 97px;
    color: #000000;
    border-top: 3px solid transparent;
  }
  .nav-top2 .el-submenu__title{
    font-size: 20px;
    color: transparent;
  }
  .nav-top2 .el-menu li.el-menu-item{
    border-top: 3px solid transparent;
  }
  .nav-top2 .el-submenu__icon-arrow{
    font-size: 18px;
  }
</style>



// WEBPACK FOOTER //
// src/components/navtop/navcommon2.vue